import { ReactSVG } from "react-svg";
import asset from "assets/images";

export const Tooltip = ({ text }) => (
	<div className="custom-tooltip">
		<ReactSVG src={asset?.icons?.tooltip} className="d-inline-flex" />
		<span className="tooltiptext">{text}</span>
	</div>
);
